"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var edit_icon_svg_1 = __importDefault(require("res/img/edit-icon.svg"));
var delete_icon_svg_1 = __importDefault(require("res/img/delete-icon.svg"));
var product_error_icon_svg_1 = __importDefault(require("res/img/product-error-icon.svg"));
var ProductCategoriesTableRow = function (_a) {
    var data = _a.data, products = _a.products, onDelete = _a.onDelete;
    var errorHandler = function (e) {
        e.currentTarget.src = product_error_icon_svg_1.default;
        e.currentTarget.setAttribute('data-error', 'true');
    };
    return (react_1.default.createElement("div", { className: 'table-row flex flex-row' },
        react_1.default.createElement("div", { className: 'table-row__td table-row__td-img' },
            react_1.default.createElement("div", { className: 'table-row__img' },
                react_1.default.createElement("img", { "data-error": !data.image, src: data.image && data.image.thumbnail || product_error_icon_svg_1.default, alt: data.name, onError: errorHandler }))),
        react_1.default.createElement("div", { className: 'table-row__td' },
            react_1.default.createElement("span", null, data.name)),
        react_1.default.createElement("div", { className: 'table-row__td' },
            react_1.default.createElement("span", null, data.productSubCategories && data.productSubCategories.length || 0)),
        react_1.default.createElement("div", { className: 'table-row__td' },
            react_1.default.createElement("span", null, data.count)),
        react_1.default.createElement("div", { className: 'table-row__td flex flex-row' },
            react_1.default.createElement(react_router_dom_1.Link, { to: "/products/categories/edit/" + data.id, className: 'table-row__action flex flex-column flex-center', title: 'Edit', "aria-label": 'Edit Product Category' },
                react_1.default.createElement("img", { src: edit_icon_svg_1.default, alt: 'Edit' })),
            react_1.default.createElement("button", { className: 'table-row__action flex flex-column flex-center', title: 'Delete', onClick: function () { return onDelete(data); }, "aria-label": 'Delete Product Category' },
                react_1.default.createElement("img", { src: delete_icon_svg_1.default, alt: 'Delete' })))));
};
exports.default = ProductCategoriesTableRow;
